import { del, get, put } from '@/redux/requests/api.js';

/** Lists the files of one knowledge folder the person edits by hand (`organization`). */
export const getKnowledgeFiles = ({ root } = {}, callback) => {
  return get('/v1/pieve/knowledge-files', {
    action: 'GET_KNOWLEDGE_FILES',
    loader: 'getKnowledgeFiles',
    query: { root },
    callback
  });
};

/** Creates or replaces one hand-edited knowledge file: a skill or an organization note. */
export const putKnowledgeFile = ({ path, content } = {}, callback) => {
  return put('/v1/pieve/knowledge-files', {
    action: 'PUT_KNOWLEDGE_FILE',
    loader: 'putKnowledgeFile',
    data: { path, content },
    callback
  });
};

/** Deletes one hand-edited knowledge file by its node id. */
export const removeKnowledgeFile = ({ nodeId, path } = {}, callback) => {
  return del(`/v1/pieve/knowledge/${encodeURIComponent(String(nodeId || '').trim())}`, {
    action: 'REMOVE_KNOWLEDGE_FILE',
    loader: 'removeKnowledgeFile',
    meta: { path },
    callback
  });
};
